<template>
  <div>
    <div
      v-for="log in logs"
      :key="log.id"
    >
      <div
        v-for="(entry, idx) in log.log"
        :key="idx"
        class="mb-2"
      >
        <div class="mb-2">
          <code>{{ entry.type }}</code>
        </div>
        <pre class="ml-4">{{ entry.data }}</pre>
        <v-divider class="mt-2" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { LogsRow } from '../../../../common/src/Types'

defineProps<{
  logs: LogsRow[]
}>()
</script>
